import { render, staticRenderFns } from "./DistributeCoursesModal.vue?vue&type=template&id=6fa7e97e&scoped=true&"
import script from "./DistributeCoursesModal.vue?vue&type=script&lang=js&"
export * from "./DistributeCoursesModal.vue?vue&type=script&lang=js&"
import style0 from "./DistributeCoursesModal.vue?vue&type=style&index=0&id=6fa7e97e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa7e97e",
  null
  
)

export default component.exports